module.exports = __webpack_public_path__ + "static/media/jlt2-sm.0c3275fe.jpg";